import { ref } from 'vue';

export default function useOpen(initialValue = false) {
  const open = ref(initialValue);

  const setOpen = function (openState) {
    open.value = openState;
  };

  return { open, setOpen };
}
